export const appConfig = {
  env: process.env.REACT_APP_ENV,
  urlPrefixIp: process.env.REACT_APP_API_UrlPrefix_ENDPOINT,
  urlPhpPrefixIp: process.env.REACT_APP_UrlPhpPrefix_ENDPOINT,
  urlPhpV1Ip: process.env.REACT_APP_UrlPhpV1_ENDPOINT,
  externalIp: process.env.REACT_APP_External_ENDPOINT,
};

export const momentDateFormat = "HH:mm ddd MM-DD-YYYY z";
